import React, { useEffect } from 'react';
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';

import SidebarCust from '../Layouts/SidebarCust';
import SuccessModal from '../Components/Common/CustomModal/SuccessModal';
import ErrorModal from '../Components/Common/CustomModal/ErrorModal';
import ConfirmModal from '../Components/Common/CustomModal/ConfirmModal';
import SelectDBConnectionModal from '../Components/Common/CustomModal/SelectDBConnectionModal';
import Create_New_Group_modal from '../Components/Common/CustomModal/Create_New_Group_modal';
import { Create_New_Bot } from '../slices/thunks';
import { useGeolocated } from "react-geolocated";




const Index = () => {

    const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
        positionOptions: {
            enableHighAccuracy: false,
        },
        userDecisionTimeout: 5000,
    });


    useEffect(() => {
        // Save availability and enable status to cookies
        document.cookie = `isGeolocationAvailable=${isGeolocationAvailable}; path=/; max-age=86400`;
        document.cookie = `isGeolocationEnabled=${isGeolocationEnabled}; path=/; max-age=86400`;
    
        // Save coordinates if available
        if (coords) {
          document.cookie = `latitude=${coords.latitude}; path=/; max-age=86400`;
          document.cookie = `longitude=${coords.longitude}; path=/; max-age=86400`;
        }
      }, [coords, isGeolocationAvailable, isGeolocationEnabled]);
 
   
    return (
        <React.Fragment>
            <SuccessModal/>
            <ErrorModal/>
            <ConfirmModal/>
          
            <SelectDBConnectionModal/>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <NonAuthLayout>
                                    {route.component}
                                </NonAuthLayout>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected>
                                    <VerticalLayout>  {route.component}</VerticalLayout>
                                </AuthProtected>}
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>
            </Routes>
        </React.Fragment>
    );
};

export default Index;